import { atsRequest } from "../../configs/axios.config";

class ConsultantsService {
  allConsultants(success,error) {
    return atsRequest
      .get('/api/v1/consultants?applicant_id=')
      .then(({data}) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  createNewConsultant(data,success,error) {
    return atsRequest
      .post('/api/v1/consultants',data)
      .then(({data}) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  editConsultant(data,success,error) {
    return atsRequest
      .put(`/api/v1/consultants/${data.id}`,data)
      .then(({data}) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  deleteConsultant(data,success,error) {
    return atsRequest
      .delete(`/api/v1/consultants/${data}`)
      .then(({data}) => success(data))
      .catch((errorResp) => error(errorResp));
  }
}

export const consultantsService = new ConsultantsService()